import { Injectable } from "@angular/core";
import { BaseDataResponse, BaseEntityResponse, FileView } from '@base/entities/BaseEntities';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { BaseEndpoint } from "@m4u-angular/base/endpoint/BaseEndpoint";
import { Observable } from "rxjs";
import { APIGatewayService } from "../gateway/APIGateway.service";


@Injectable()
export class FileEndpoint extends BaseEndpoint {
    //Constructor
    constructor(api: APIGatewayService) {
        super("File", api);
    }

    public GetView(uid: string, loadFile: boolean): Observable<BaseEntityResponse<FileView>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetView', { uid: uid, loadFile: loadFile });
    }

    public GetViewByID(entryID: number, loadFile: boolean): Observable<BaseEntityResponse<FileView>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetViewByID', { entryID: entryID, loadFile: loadFile });
    }
}
